
import React, {useEffect} from 'react';
import './RightContainer.css'; // Import CSS for styling
// import styles from './ChartEmas'
import ChartEmas from './ChartEmas';
import TRViwerSymbolHelth from './TRViwerSymbolHelth';
import StreamCryptoCInfo from './StreamCryptoCInfo';
import StreamMostBuySell from './StreamMostBuySell';
import FearAndGreedDashboard from './FearAndGreedDashboard';
import { useNavigate } from 'react-router-dom';
// import StreamFacts from './StreamFacts';

function RightContainer() {

    const navigate = useNavigate();
    
    const handlePage = (page) => {
        navigate(`/${page}`);
    };
    
    useEffect(() => {
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    
        if (isSafari) {
          document.getElementById('fearAndGreedContainer').style.left = '60px';
        }
      }, []);

    return (
        <div className="right-container scrollableContainer">
            <div style={{ width: '100%', height: '135px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ flex: 1, marginRight: '20px' }}>
                    <StreamMostBuySell />
                </div>
                <div id='fearAndGreedContainer' onClick={() => handlePage('FearAndGreed')} style={{ flex: 1, width:'200px', top: '-15px', left: '-60px', position:'relative', cursor:'pointer' }}>
                    <FearAndGreedDashboard diameter={250} coverPosition={0} showDetails={false} />
                </div>
            </div>           
            <StreamCryptoCInfo/>
            <ChartEmas/>            
            <div className="center-container">
                <TRViwerSymbolHelth/>          
            </div>            
        </div>
    );
}

export default RightContainer;
